import { Host } from '@/host'

export class SpotifyClient {
  private appHost: string = ''

  constructor() {
    this.appHost = new Host().rest
  }

  public getLoginUrl(artistIds: string[], partyId: number): string {
    const grantToken = localStorage.getItem('party_grant_token')
    const redirectURI = window.location.origin + window.location.pathname + '#/register'
    const url = new URL(`${this.appHost}/api/auth/spotify/login`)
    url.searchParams.set('hash_output', 'false')
    url.searchParams.set('redirect_uri', redirectURI)
    url.searchParams.set('party_id', partyId.toString())
    if (grantToken) {
      url.searchParams.set('grant', grantToken)
    }
    if (artistIds && artistIds.length) {
      url.searchParams.set('artist_ids', artistIds.join(','))
    }

    return url.toString()
  }
}
